const styleSheet = () => ({
  flexWrapper: {
    // Need to change this for flexible widths.  Make it a flex one
    // overflow: "auto",
    maxWidth: '100%',
    width: '100%',
    margin: '0 auto',
    padding: '1rem',
    paddingRight: '0px',
    paddingBottom: '0px',
    paddingTop: 0,
  },
  dateRangePadding: {
    paddingBottom: '0.6rem',
  },
  titlePadding: {
    paddingBottom: '0.9rem',
  },
  baseText: {
    fontFamily: "'Museo Sans', sans-serif",
    fontWeight: '500',
  },
  boldText: {
    fontFamily: "'Museo Sans', sans-serif",
    fontWeight: 700,
  },
  mediumText: {
    fontFamily: "'Museo Sans', sans-serif",
    fontWeight: 500,
  },
  audienceTitle: {
    height: '30px',
    color: '#051D39',
    fontSize: '24px',
    lineHeight: '30px',
  },
  audienceTotal: {
    height: '46px',
    color: '#051D39',
    fontSize: '36px',
    lineHeight: '46px',
    marginRight: '5px',
    paddingRight: '.35rem',
  },
  checkedCountText: {
    height: '46px',
    color: '#085FE5',
    fontSize: '36px',
    lineHeight: '46px',
    marginRight: '5px',
    paddingRight: '.35rem',
  },
  audienceTotalText: {
    height: '22px',
    color: '#051D39',
    fontSize: '16px',
    lineHeight: '22px',
  },
  selectedHidden: {
    visibility: 'hidden',
  },
  selectedCount: {
    color: '#085FE5',
    fontSize: '14px',
    lineHeight: '18px',
    paddingLeft: '4px',
    opacity: (props: any) => (props.checkedBoxCount > 0 ? 1 : 0),
  },
  dateRangeText: {
    height: '20px',
    width: '155px',
    color: '#6373A4',
    fontSize: '16px',
    lineHeight: '20px',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    '@media (max-width: 1110px)': {
      flexDirection: 'column',
      justifyContent: 'space-between',
      gap: '20px',
    },
    '@media (max-width: 1410px)': {
      justifyContent: 'flex-start',
    },
    flexWrap: 'nowrap',
    justifyContent: 'space-between',
    width: '100%',
    marginLeft: '1.75px',
  },
  column: {},
  exportWrapper: {
    '& button': {
      margin: '0 8px',
    },
    '& :first-child': {
      marginLeft: 0,
    },
    '& :last-child': {
      marginRight: 0,
    },
  },
  listName: {
    height: '30px',
    width: '382px',
    color: '#051D39',
    fontSize: '24px',
    lineHeight: '30px',
  },
  more: {
    height: '28px',
    width: '28px',
    borderRadius: '4px',
    backgroundColor: 'rgba(5, 29, 57, 0.1)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  moreIcon: {
    '& circle': {
      fill: '#085FE5',
    },
  },
});

export default styleSheet;
